import React, { useState } from "react";
import { useSelector } from "react-redux";
import Button from "@mui/material/Button";
import {Empty, Divider, Layout} from 'antd';
import {ArrowLeft} from "@mui/icons-material";
import PageCollection from "./PageCollection";
import PortfolioPageForm from "./PortfolioPageForm";
import {selectUserFields} from "../../../store/slices/user.slice";
import PageHeader from "../../../layouts/PageHeader";
import {iconMapping} from "../../../configs/AppsConfig";


const PortfolioPages = ()=>{
    const pages = useSelector((state)=>selectUserFields(state, 'page_details'));
    const [selectedPage, setSelectedPage] = useState(null);
    const [isEditing, setIsEditing] = useState(false);

    const handleEdit = (page) => {
        setSelectedPage(page);
        setIsEditing(true);
    };




    if (!Array.isArray(pages) || pages.length === 0) {
        return <Empty />;
    }

    const EditView = ()=>{
        return (
            <div style={{maxWidth: 1200, margin: 'auto'}}>
                <Divider/>
                <PortfolioPageForm initialValues={selectedPage} pageId={selectedPage?.page_id} toggleBack={()=>setIsEditing(false)}/>
            </div>
        )
    }
  return (
      <Layout>
          <PageHeader logoUrl={iconMapping.iq} logoSize={43} actions={
              isEditing ? [
                  <Button onClick={()=>setIsEditing(false)} startIcon={<ArrowLeft/>}  color={'primary'} variant={'contained'} size={'large'}>Back To IQ COLLECTION</Button>
              ] : []
          }/>
          <Layout.Content style={{padding: 50}}>
              {isEditing ? <EditView/> : <PageCollection
                  pageData={pages}
                  onEdit={handleEdit}
                  onNewPage={()=>setIsEditing(true)}
              />}
          </Layout.Content>

      </Layout>
  );
}

export default PortfolioPages;